// File: SocialMediaAnalysisViewChart.jsx
import React, { useCallback, useId, useState } from "react";
import DFOAnalysisChart from "./DFOAnalysisChart";
import DFOVolumeAnalysisChart from "./DFOVolumeAnalysisChart";
import SocialMediaVolumeAnalysisChart from "./SocialMediaVolumeAnalysisChart";
import "./socialmediaanalysisview.css";

const TAB_ITEMS = [
  { key: "Social Media Volume Analysis", label: "Social Media Volume Analysis", content: <SocialMediaVolumeAnalysisChart /> },
  { key: "DFO Volume Analysis", label: "DFO Volume Analysis", content: <DFOVolumeAnalysisChart /> },
  { key: "Key Information Topic Analysis", label: "Key Information Topic Analysis", content: <DFOAnalysisChart /> },
];

const SocialMediaAnalysisViewChart = () => {
  const [active, setActive] = useState(0);
  const baseId = useId();

  const onKeyDown = useCallback(
    (e) => {
      if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
        e.preventDefault();
        const dir = e.key === "ArrowRight" ? 1 : -1;
        const next = (active + dir + TAB_ITEMS.length) % TAB_ITEMS.length;
        setActive(next);
        const btn = document.getElementById(`${baseId}-tab-${next}`);
        btn?.focus();
      }
    },
    [active, baseId]
  );

  return (
    <div className="download-sec">
      <div className="row chart-view">
        <div className="col">
          <div className="social-chart-section">
            {/* Mobile select */}
            <div className="sma-select-wrap">
              <label htmlFor={`${baseId}-tabs`} className="sr-only">
                Select tab
              </label>
              <select
                id={`${baseId}-tabs`}
                className="sma-select"
                value={active}
                onChange={(e) => setActive(parseInt(e.target.value, 10))}
              >
                {TAB_ITEMS.map((t, idx) => (
                  <option key={t.key} value={idx}>
                    {t.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Desktop tabs */}
            <ul className="sma-tabslist" role="tablist" aria-label="Social media analysis tabs">
              {TAB_ITEMS.map((t, idx) => (
                <li className="sma-tabitem" key={t.key}>
                  <button
                    id={`${baseId}-tab-${idx}`}
                    type="button"
                    role="tab"
                    aria-selected={active === idx}
                    aria-controls={`${baseId}-panel-${idx}`}
                    tabIndex={active === idx ? 0 : -1}
                    className={`sma-tab ${active === idx ? "sma-tab--active" : ""}`}
                    onClick={() => setActive(idx)}
                    onKeyDown={onKeyDown}
                  >
                    {t.label}
                  </button>
                </li>
              ))}
            </ul>

            {/* Panels */}
            <div className="sma-panels">
              {TAB_ITEMS.map((t, idx) => (
                <div
                  key={t.key}
                  id={`${baseId}-panel-${idx}`}
                  role="tabpanel"
                  aria-labelledby={`${baseId}-tab-${idx}`}
                  hidden={active !== idx}
                  className="sma-panel"
                >
                  {t.content}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialMediaAnalysisViewChart;